import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-caption font-semibold transition-colors",
  {
    variants: {
      variant: {
        default: "bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300",
        secondary: "bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-300",
        outline: "border border-neutral-300 text-neutral-700 bg-white dark:border-neutral-700 dark:text-neutral-300 dark:bg-neutral-900",
        success: "bg-success-50 text-success-700 dark:bg-success-500/15 dark:text-success-300",
        warning: "bg-warning-50 text-warning-700 dark:bg-warning-500/15 dark:text-warning-300",
        danger: "bg-danger-50 text-danger-700 dark:bg-danger-500/15 dark:text-danger-300",
        accent: "bg-accent-50 text-accent-700 dark:bg-accent-900/40 dark:text-accent-300",
        live: "bg-live-50 text-live-600 dark:bg-live-500/15 dark:text-success-300",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
